import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white" data-id="element-118">
      <div className="max-w-3xl mx-auto text-center" data-id="element-119">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-120">
          🏆 Offerta Speciale di Lancio
        </h2>

        <div className="bg-white rounded-[2rem] border-2 border-brand-green p-8 md:p-12 shadow-xl relative max-w-xl mx-auto" data-id="element-121">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-white px-6 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-122">
            CONTENUTI DEL KIT:
          </div>

          <div className="space-y-4 mb-8 text-left" data-id="element-123">
            <div className="flex justify-between items-center border-b border-brand-creamDark pb-4" data-id="element-124">
              <span className="text-brand-text font-medium" data-id="element-125">
                6 Volumi digitali completi
              </span>
              <span className="text-brand-terracotta font-medium" data-id="element-126">€ 50</span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-creamDark pb-4" data-id="element-127">
              <span className="text-brand-text font-medium" data-id="element-128">
                6 Bonus esclusivi
              </span>
              <span className="text-brand-terracotta font-medium" data-id="element-129">€ 96</span>
            </div>
            <div className="flex justify-between items-center pt-2" data-id="element-130">
              <span className="font-bold text-brand-text" data-id="element-131">VALORE TOTALE:</span>
              <span className="font-bold text-brand-terracotta" data-id="element-132">€ 146</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-133">
            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-134">
              <span className="text-4xl" data-id="element-135">🏆</span>
              <span className="text-6xl md:text-7xl font-black text-brand-green tracking-tight" data-id="element-136">
                € 19
              </span>
            </div>
            <span className="text-brand-gray line-through font-medium text-lg" data-id="element-137">
              € 146
            </span>
          </div>

          <CTAButton href="https://yoga-pronta.impultienda.ar/checkout" className="w-full mb-3 text-lg py-5" data-id="element-138">
            SÌ, VOGLIO YOGA PRONTA
          </CTAButton>

          <p className="mb-3 text-xs font-bold text-brand-terracotta" data-id="element-139">
            ⚡ Prezzo di lancio valido solo per le prossime 48 ore.
          </p>
          <p className="text-xs text-brand-gray font-medium" data-id="element-140">
            Pagamento sicuro &middot; Pagamento unico &middot; Accesso a vita
            &middot; Garanzia 14 giorni
          </p>
        </div>
      </div>
    </section>;
}